// extracted by mini-css-extract-plugin
export default {"cardHeaderIcon":"c-e_ch","cardHeaderIcon__content":"c-e_ci"};